export function DifferentialsSection() {
  const differentials = [
    {
      icon: 'ri-time-line',
      title: 'Laudos Rápidos',
      description: 'Resultados disponíveis com agilidade, com possibilidade de urgência quando necessário.',
      color: 'from-blue-500 to-teal-500'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Ambiente Confortável',
      description: 'Instalações modernas e acolhedoras, pensadas para proporcionar tranquilidade durante sua visita.',
      color: 'from-teal-500 to-blue-500'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Equipe Experiente',
      description: 'Profissionais altamente qualificados com anos de experiência em diagnóstico por imagem.',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Fácil Acesso',
      description: 'Localização privilegiada com fácil acesso.',
      color: 'from-indigo-500 to-purple-500'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Agendamento Online',
      description: 'Agende seus exames de forma rápida e prática através de nossos telefones ou WhatsApp.',
      color: 'from-pink-500 to-rose-500'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-star-line"></i>
            <span>Nossos Diferenciais</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Por Que Escolher a Nova Imagem?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Oferecemos muito mais do que exames. Proporcionamos uma experiência completa de cuidado e atenção.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {differentials.map((item, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
